/**
 * Changes strings to camelCase
 * @param {string} wordStrings - a number of strings that are in snake_case or kebab-case
 * @returns {string} A string in camelCase
 */
export default function toCamelCase(...wordStrings: string[]): string {
  const array: string[] = [];
  wordStrings.forEach((words) => array.push(...words.split('/[-_]/')));
  return array
    .map((word: string, index: number) =>
      index
        ? word.charAt(0)?.toUpperCase() + word.slice(1)
        : word.charAt(0)?.toLowerCase() + word.slice(1),
    )
    .join('');
}
